// 第1张
const imgAll1 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723604883179/Frame%201000008956.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723606077380/%E5%A4%9A%E7%A7%8D%E7%BB%84%E5%90%88%E5%85%85%E7%94%B5.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724644501494/a3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724644501749/b3.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725153963939/euPC5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725153964490/euH5.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725160503863/ukPC5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725160504772/ukH5.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAll1.JP,
    us: imgAll1.NA,
    ca: imgAll1.NA,
    br: imgAll1.NA,
    mx: imgAll1.NA,
    uk: imgAll1.UK,
    eu: imgAll1.EU,
    de: imgAll1.EU,
    fr: imgAll1.EU,
    it: imgAll1.EU,
    es: imgAll1.EU,
    nl: imgAll1.EU,
};
export default imgLocale1;
